<template>
	<apexchart
		:width="width"
		:height="dynamicHeight"
		:options="chartOptions"
		:series="parsedData"
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "QueueTotals",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    width: {
      type: [Number, String],
      default: "100%",
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
    value: {
      type: Number,
      default: 75,
    },
    data: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data() {
    return {
			barHeight: 35, // Aumentado de 20 para 35
      categories: [],
    };
  },
  computed: {
    parsedData() {
      const dataArray = [
        {name: "Ligações atendidas", data: []},
        {name: "Ligações abandonadas", data: []},
      ];

      if (this.data && typeof this.data === 'object') {
        const sortable = Object.entries(this.data).map(([key, value]) => {
          const answered = value && typeof value.answered === 'number' ? value.answered : 0;
          const abandoned = value && typeof value.abandoned === 'number' ? value.abandoned : 0;
          return [key, value, answered + abandoned];
        });

        sortable.sort((a, b) => b[2] - a[2]);

        this.categories = sortable.map(item => item[0]);
        dataArray[0].data = sortable.map(item => item[1] && typeof item[1].answered === 'number' ? item[1].answered : 0);
        dataArray[1].data = sortable.map(item => item[1] && typeof item[1].abandoned === 'number' ? item[1].abandoned : 0);
      }

      return dataArray;
    },
    dynamicHeight() {
      const categoriesCount = this.categories.length;
      const spacingPerCategory = 15; // Reduzido de 30 para 15
      const titleAndLegendSpace = 80; // Aumentado um pouco para acomodar título e legenda

			const total = (categoriesCount * (this.barHeight + spacingPerCategory)) + titleAndLegendSpace;
      
			return total
		},
    
    chartOptions() {
      return {
        title: {
          text: "Ligações Entrantes por Fila",
          align: "center",
          style: {
            fontSize: "14px",
            fontWeight: "bold",
          },
        },
        chart: {
          type: "bar",
          stacked: true,
          height: this.dynamicHeight,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          },
          stackOnlyBar: true // Força o comportamento de stack
        },
        colors: ["#4da6ff", "#ff6666"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: `${this.barHeight}px`, // Especificando em pixels
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 5,
                style: {
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#373d3f',
                  backgroundColor: '#1c869a'
                }
              }
            },
            groupPadding: 0.1, // Reduzido de 0.3 para 0.1
            categoryGap: '20%', // Reduzido de 100% para 20%
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff"],
            fontSize: "11px",
            fontWeight: "bold",
          },
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 1,
            opacity: 0.9,
            color: "black",
          },
        },
        xaxis: {
          categories: (!this.data || typeof this.data !== 'object' || Array.isArray(this.data) || !Object.keys(this.data).length)
            ? []
            : Object.keys(this.data),
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            show: false,
            formatter: (val) => `${val}%`,
          },
        },
        yaxis: {
          show: !!this.categories.length,
        },
        grid: {
          show: !!this.categories.length,
          padding: {
            right: 60
          }
        },
        tooltip: {
          enabled: true,
        },
        legend: {
          show: true,
          position: "top",
        },
      };
    },
  },
};
</script>

<style scoped>
.example {
  padding: 0 10px;
}
</style>